import { useState, useEffect } from "react"

import Filter from "./filter"
import ReceiptTile from "./flatReceiptTile"

function FlatReceiptTable({
    chargerNameIdPair,
    usersInCriteria,
    receipts
}) {

    const [compliesWithFilters, setCompliesWithFilters] = useState({})
    const [selectedUsers, setSelectedUsers] = useState([])

    // Apply user filter to dataset.
    // If no users are selected treat it as all users are selected.

    useEffect(() => {
        if (!receipts.data) return
        if (selectedUsers.length === 0) {
            setCompliesWithFilters(receipts.data)
            return
        }
        let newDataObject = {}
        Object.entries(receipts.data).forEach(([key, charger]) => {
            if (Array.isArray(charger)) {
                const complies = charger.filter(receipt => selectedUsers.includes(receipt.user));
                newDataObject[key] = complies;
            }
        });
        setCompliesWithFilters(newDataObject)

    }, [selectedUsers, receipts])

    return (
        <div className="h-full w-[calc(100vw-390px)] ">
            <Filter
                usersInCriteria={usersInCriteria}
                setSelectedUsers={setSelectedUsers}
                selectedUsers={selectedUsers}
                compliesWithFilters={compliesWithFilters}
                chargerNameIdPair={chargerNameIdPair}
            />
            <div className="w-full h-[calc(100%-40px)] overflow-y-scroll dashboardScrollBar">
                {compliesWithFilters &&
                    Object.entries(compliesWithFilters).map(([key, charger], chargerIndex) => {
                        return (
                            <div key={chargerIndex} className="">
                                <h2 className="font-semibold italic h-10 bg-white flex items-center pl-2 border-t-[1px] border-b-[1px] border-gray-300 -mt-[1px] shadow-md ">{chargerNameIdPair[key]}</h2>
                                {Array.isArray(charger) && charger.map((receipt, index) => (
                                    // <div key={index} className="w-full h-8 grid grid-cols-12 bg-gray-200">
                                    //     {receipt.end_time}
                                    // </div>
                                    <ReceiptTile
                                        key={index}
                                        receipt={receipt}
                                    />
                                ))}
                            </div>
                        );
                    })}
            </div>
        </div>
    )
}

export default FlatReceiptTable